export default __webpack_public_path__ + "static/media/boost_async_ext_mosfet_vcc_is_vin.4ef5ebce.svg";